let inject = [
  '$scope',
  'proceedingsListService',
  '$state',
  '$rootScope',
  '$timeout',
  'SessionService'
];

class ProceedingsListController {
  constructor($scope, proceedingsListService, $state, $rootScope, $timeout, SessionService) {
    this.$state = $state;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.$rootScope = $rootScope;
    this.proceedingsListService = proceedingsListService;
    this.activities = [];
	this.SessionService = SessionService;

  }

  $onInit() {
	  this.shCtrl.activate();
	this.order = 'date_entered';
	this.desc = true;
	this.sucursales = this.shCtrl.globals.currentUser.sucursales;
	this.userId = this.shCtrl.globals.currentUser.userId;
	this.sessionId = this.shCtrl.globals.currentUser.sessionCrm;
    this.filter = {};
	this.cacheFilter = {
		firtsConsulta : true
	};
	
	this.currentPage = 1;
	this.currentPageCache = 0;
    this.getActivities();
	
	this.totalItems = 0;
	this.totalPages = 1;
	
	this.detalle = {};
	
	this.sucursales = {};
	
	this.ultimaActualizacion = '';
	
  }
  
  orderBy(name) {
	  if(this.order == name) {
		  this.desc = !this.desc;
	  }else {
		  this.order = name;
		  this.desc = true;
	  }
	  
	  this.getActivities(true);
  }

  getActivities(ordenar=false) {
	if((!angular.equals(this.filter, this.cacheFilter) || this.currentPage != this.currentPageCache) || ordenar) {
		this.currentPageCache = angular.copy(this.currentPage);
		this.cacheFilter = angular.copy(this.filter);
		this.loading = true;
		this.error = false;
		this.errorMsg = '';
		
		this.data = {
					'userId' : this.userId,
					'pageNumber' : (this.currentPage) ? this.currentPage : 1,
					'pageSize' : 20,
					'filter' : this.filter,
					'consulta' : 'actas',
					'order'		: this.order,
					'desc'		: this.desc
					};
					
		this.proceedingsListService.getActivitiesData(this.data).then(response => {
			this.loading = false;
			
			if(response.error) {
				this.error = true;
				this.errorMsg = response.mensaje;
			}else {
				this.activities = response.actividades;
				this.totalItems = response.totalItems;
				this.totalPages = response.totalPage;
				this.sucursales = response.sucursales;
				
				this.ultimaActualizacion = response.ultimaActualizacion;
				
				/*this.activities.forEach((value,key)=>{
					value.description = this.decodeEntities(value.description);
				});*/
			}
			if((this.error || !this.activities.length) && this.errorMsg == '') {
					this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
			}
		}).catch(reason => {
			  this.loading = false;
			  this.error = true;
			  if(this.error && this.errorMsg == '') {
					this.errorMsg = 'No se han encontrado registros que coincidan con los filtros seleccionados';
			}
		});
	}
  }
  


   exportarXls() {
	  this.exportLoading = true;
	  

	  let data = {
		  'pageNumber' : 1,
		  'pageSize' : this.totalItems,
		  'userId' : this.userId,
		  'filter' : this.filter,
		  'consulta' : 'actas',
		  'order'		: this.order,
		  'desc'		: this.desc
	  };
	  this.proceedingsListService.exportarXls(data).then(response => {
		
		this.exportLoading = false;
        let ruta = response.split('/');
		
		var link = document.getElementById("labelprueba");
        link.setAttribute("href", response);
        link.setAttribute("download", ruta[ruta.length - 1]);
        link.click();
    }).catch(reason => {
		$this.exportLoading = false;
	});
  }
  
   exportarPdf() {
	  this.exportLoading = true;
	  

	  let data = {
		  'userId' : this.userId,
		  'tipoDoc' : 'actas',
		  'id' : this.detalle.referencia,
		  'nombreDocumento' : this.detalle.rut,
	  };
	  this.proceedingsListService.exportarPdf(data).then(response => {
		
		this.exportLoading = false;
        let ruta = response.split('/');
		
		var link = document.getElementById("labelprueba");
        link.setAttribute("href", response);
        link.setAttribute("download", ruta[ruta.length - 1]);
        link.click();
    }).catch(reason => {
		$this.exportLoading = false;
	});
  }

}

ProceedingsListController.$inject = inject;

export default ProceedingsListController;




/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/consult-crm/proceedings-list/proceedings-list.controller.js
 **/